/**
 * MM branch inventory: Liquid JSON (store_availabilities) + live qty from /variants/{id}.js
 * 
 * IMPORTANT: store_availabilities in Shopify have delayed propagation (can take hours 
 * after inventory changes). The Liquid JSON embedded in the page is the most current 
 * source. This JS refreshes quantity data via /variants/{id}.js for urgency strips.
 */
(function () {
  function readLabels(root) {
    return {
      available: root.getAttribute('data-mm-inv-available') || 'Available',
      unavailable: root.getAttribute('data-mm-inv-unavailable') || 'Unavailable',
      allLocations: root.getAttribute('data-mm-inv-all-locations') || 'In stock at all locations',
      oneBranchHint:
        root.getAttribute('data-mm-inv-one-branch') ||
        'In stock at one listed location only — see branches below',
      urgency: root.getAttribute('data-mm-inv-urgency') || 'Order soon — selling fast!',
      remaining: root.getAttribute('data-mm-inv-remaining') || 'Only',
      instock: root.getAttribute('data-mm-inv-instock') || 'In stock',
    };
  }

  function findPayloadScript(root) {
    var host = root.closest('.mmshop-card, .mms-card, .mm-cart-item, .mmupi-container');
    if (host) {
      var s = host.querySelector('script.mm-inv-payload[type="application/json"]');
      if (s) return s;
    }
    var sec = root.closest('section.mmupi');
    if (sec) {
      var s2 = sec.querySelector('script.mm-inv-payload[type="application/json"]');
      if (s2) return s2;
    }
    return root.querySelector('script.mm-inv-payload[type="application/json"]');
  }

  function parsePayload(root) {
    var s = findPayloadScript(root);
    if (!s || !s.textContent) return null;
    try {
      return JSON.parse(s.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function getVariantPayload(data, variantId) {
    if (!data) return null;
    var k = String(variantId);
    if (data[k]) return data[k];
    var n = Number(variantId);
    if (!isNaN(n) && data[String(n)]) return data[String(n)];
    return null;
  }

  function render(root, variantId, freshQty) {
    var data = parsePayload(root);
    var mount = root.querySelector('.mm-inv-mount');
    if (!mount || !data) return;

    var v = getVariantPayload(data, variantId);
    if (!v) {
      mount.innerHTML = '';
      return;
    }

    var labels = readLabels(root);
    var branches = Array.isArray(v.b) ? v.b : [];
    var q =
      freshQty != null && typeof freshQty === 'number' && !isNaN(freshQty)
        ? freshQty
        : v.q != null && typeof v.q === 'number'
          ? v.q
          : null;

    mount.innerHTML = '';
    var frag = document.createDocumentFragment();
    var shopListing = root.classList.contains('mm-inv--shop-below');

    if (branches.length > 0) {
      var allOut = branches.every(function (b) {
        return !b.a;
      });
      var availableCount = branches.filter(function (b) {
        return b.a;
      }).length;

      if (allOut) {
        var only = document.createElement('div');
        only.className = 'mm-inv-row mm-inv-oos-only';
        only.textContent = labels.unavailable;
        frag.appendChild(only);
      } else {
        if (!shopListing && branches.length >= 2 && availableCount === 1) {
          var hint = document.createElement('div');
          hint.className = 'mm-inv-row mm-inv-partial-hint';
          hint.setAttribute('role', 'status');
          hint.textContent = labels.oneBranchHint;
          frag.appendChild(hint);
        }
        branches.forEach(function (b) {
          var row = document.createElement('div');
          row.className = 'mm-inv-row';
          var name = document.createElement('span');
          name.className = 'mm-inv-loc';
          name.textContent = (b.n || '') + ' — ';
          var st = document.createElement('span');
          st.className = b.a ? 'mm-inv-yes' : 'mm-inv-no';
          st.textContent = b.a ? labels.available : labels.unavailable;
          row.appendChild(name);
          row.appendChild(st);
          frag.appendChild(row);
        });
      }
    } else {
      var row = document.createElement('div');
      row.className = 'mm-inv-row' + (v.av ? '' : ' mm-inv-oos-only');
      if (v.av) {
        var ok = document.createElement('span');
        ok.className = 'mm-inv-yes';
        ok.textContent = labels.instock;
        row.appendChild(ok);
      } else {
        row.textContent = labels.unavailable;
      }
      frag.appendChild(row);
    }

    if (!shopListing && q != null && q > 0 && q < 10) {
      var urg = document.createElement('div');
      urg.className = 'mm-inv-urgency';
      urg.innerHTML =
        '<span class="mm-inv-urg-icon" aria-hidden="true">⚡</span><span>' +
        labels.urgency +
        ' — ' +
        labels.remaining +
        ' ' +
        q +
        '</span>';
      frag.appendChild(urg);
    }

    mount.appendChild(frag);
  }

  function rootsMatchingVariant(variantId) {
    var want = String(variantId);
    return Array.prototype.filter.call(document.querySelectorAll('.mm-inv-root'), function (el) {
      return String(el.getAttribute('data-variant-id')) === want;
    });
  }

  var inFlightVariantFetches = {};

  function refreshFromApi(root, variantId) {
    render(root, variantId, null);
    var id = parseInt(variantId, 10);
    if (!id) return;
    var key = String(id);

    function applyQty(qty) {
      rootsMatchingVariant(variantId).forEach(function (el) {
        render(el, variantId, qty);
      });
    }

    if (inFlightVariantFetches[key]) {
      inFlightVariantFetches[key].then(function (qty) {
        applyQty(qty);
      });
      return;
    }

    inFlightVariantFetches[key] = fetch('/variants/' + id + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('variant');
        return r.json();
      })
      .then(function (vr) {
        var qty =
          typeof vr.inventory_quantity === 'number' && !isNaN(vr.inventory_quantity)
            ? vr.inventory_quantity
            : null;
        applyQty(qty);
        return qty;
      })
      .catch(function () {
        applyQty(null);
        return null;
      })
      .finally(function () {
        delete inFlightVariantFetches[key];
      });
  }

  /**
   * Switch a shop/mobile card's inventory display to show a specific variant's branch data.
   * If variantId is empty/falsy, revert to product-level display ("_product_").
   */
  function updateShopCard(cardEl, variantId) {
    if (!cardEl) return;
    var vid = variantId && variantId !== '' && variantId !== '0' ? String(variantId) : '_product_';
    cardEl.querySelectorAll('.mm-inv-root').forEach(function (el) {
      el.setAttribute('data-variant-id', vid);
      if (vid === '_product_') {
        render(el, vid, null);
      } else {
        var data = parsePayload(el);
        var vData = getVariantPayload(data, vid);
        if (vData && vData.b && vData.b.length > 0) {
          render(el, vid, null);
        } else {
          refreshFromApi(el, vid);
        }
      }
    });
  }

  window.MMBranchInventory = {
    init: function (context) {
      var root = context || document;
      root.querySelectorAll('.mm-inv-root').forEach(function (el) {
        var vid = el.getAttribute('data-variant-id');
        if (vid) refreshFromApi(el, vid);
      });
    },
    updateCard: function (cardEl, variantId) {
      if (!cardEl || !variantId) return;
      cardEl.querySelectorAll('.mm-inv-root').forEach(function (el) {
        el.setAttribute('data-variant-id', variantId);
        refreshFromApi(el, variantId);
      });
    },
    updateShopCard: updateShopCard,
    updateProductPage: function (variantId) {
      if (!variantId) return;
      document.querySelectorAll('section.mmupi .mm-inv-root').forEach(function (el) {
        el.setAttribute('data-variant-id', variantId);
        refreshFromApi(el, variantId);
      });
    },
    updateGallery: function (variantId) {
      window.MMBranchInventory.updateProductPage(variantId);
    },
  };

  function bootMmBranchInventory(scope) {
    var ctx = scope || document;
    window.MMBranchInventory.init(ctx);
    var vidInput = document.getElementById('mmupiVariantId');
    if (vidInput && vidInput.value) {
      window.MMBranchInventory.updateProductPage(String(vidInput.value));
    }
  }

  function scheduleMmBranchInventoryBoot(scope) {
    bootMmBranchInventory(scope);
    setTimeout(function () {
      bootMmBranchInventory(scope);
    }, 0);
    setTimeout(function () {
      bootMmBranchInventory(scope);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleMmBranchInventoryBoot(document);
    });
  } else {
    scheduleMmBranchInventoryBoot(document);
  }

  window.addEventListener('load', function () {
    bootMmBranchInventory(document);
  });

  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) scheduleMmBranchInventoryBoot(document);
  });

  if ('onpagereveal' in window) {
    window.addEventListener('pagereveal', function () {
      scheduleMmBranchInventoryBoot(document);
    });
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (t && t.nodeType === 1 && typeof t.querySelector === 'function' && t.querySelector('.mm-inv-root')) {
      scheduleMmBranchInventoryBoot(t);
    }
  });
})();
